const updates = [
  { date: '07-31', title: '久久视频片源库更新，新增50+部高清电影', tag: '片源更新' },
  { date: '07-30', title: '小蓝视频独家上线热门综艺最新季', tag: '独家上线' },
  { date: '07-29', title: '豆花视频免费专区扩充，新增百部经典剧集', tag: '免费扩充' },
  { date: '07-28', title: '播放引擎升级至V3.2，加载速度提升40%', tag: '技术升级' },
  { date: '07-27', title: '久久视频动漫频道新增10部热门番剧', tag: '新番上线' },
  { date: '07-26', title: '小蓝视频纪录片频道全面改版上线', tag: '频道改版' },
  { date: '07-25', title: '移动端适配优化，手机观影体验更流畅', tag: '体验优化' },
  { date: '07-24', title: '豆花视频韩剧专区新增高分剧集20部', tag: '内容上新' },
  { date: '07-23', title: '智能推荐算法更新，个性化推荐更精准', tag: '智能升级' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">最新动态</h2>
            <p className="text-sm md:text-base text-foreground-600">
              久久视频、小蓝视频、豆花视频内容与功能每日更新动态
            </p>
          </div>
          <div className="relative pl-8 border-l-2 border-background-200/70">
            {updates.map((item, i) => (
              <div key={i} className="relative mb-6 last:mb-0">
                <div className="absolute -left-[33px] top-0.5 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex flex-wrap items-baseline gap-2 mb-1">
                  <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded">{item.date}</span>
                  <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-sm text-foreground-800 leading-relaxed">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}